import { render, staticRenderFns } from "./InfoHorario.vue?vue&type=template&id=ba5b85aa&scoped=true"
import script from "./InfoHorario.vue?vue&type=script&lang=js"
export * from "./InfoHorario.vue?vue&type=script&lang=js"
import style0 from "./InfoHorario.vue?vue&type=style&index=0&id=ba5b85aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba5b85aa",
  null
  
)

export default component.exports